export default {
  common: {
    cancel: "Cancel",
    add: "Add",
    back: "Back", 
    next: "Next", 
    submit: "Submit",
    saving: "Saving…",
    saved: "Saved ✓",
  },
  menu: {
    backToDashboard: "Back to dashboard",
    myObjects: "My accommodations",
    settings: "Settings",
    help: "Help / Contact",
    logout: "Log out",
    language: "English",
  },
  contact: {
    title: "Contact",
    subtitle: "How can we help you?",
    messageLabel: "Your message",
    send: "Send message",
    success: "Message sent successfully!",
    close: "Close",
  },
  dashboard: {
  welcome: "Welcome back, ",
  overview: "My Overview",
  summaryText: "Here you can quickly see the status of your accommodations.",
  activeObjects: "object(s) online",
  inReviewObjects: "object(s) under review",

  contact: "My Contact Info",
  editContact: "Edit",

  settings: "My Settings",
  subscription: "Subscription",
  subscriptionActive: "Active",
  password: "Password",
  changePassword: "Change password",

  objects: "My accommodations",
  objectboxText: "Edit availability and prices",
  objectboxText2: "Edit accommodation data",
  objectbuttonText: "Edit accommodations",

  newObjectContainer: "Create new accommodation",
  newObjectDescription: "Create a new accommodation or continue an existing draft.",
  continueDraft: "➜ Continue draft",
  newObject: "+ create new accommodation",

  documents: "Documents",
  lastInvoice: "Last invoice",
  openArchive: "Open archive",
},
contactEdit: {
  title: "Edit contact details",
  errorLoading: "Error loading data.",
  errorSaving: "Error saving data.",
  confirmLeave: "Do you want to save your changes?",
  salutation: "Salutation",
  selectSalutation: "Please select a salutation",
  company: "Company",
  firstName: "First name",
  lastName: "Last name",
  street: "Street",
  houseNumber: "House number",
  postalCode: "Postal code",
  town: "City/Town",
  country: "Country",
  selectCountry: "Please select a country",
  phone: "Phone number",
  cancel: "Cancel",
  save: "Save",
  requiredFields: "Please fill in all required fields.",
},
registerUser: {
  title: "Contact details",
  verifiedMessage: "Your email has been successfully verified. Please enter your contact details.",

  // Form labels
  salutation: "Salutation",
  selectSalutation: "Please select a salutation",
  company: "Company (optional)",
  firstName: "First name",
  lastName: "Last name",
  street: "Street",
  houseNumber: "House number",
  postalCode: "Postal code",
  town: "City / Town",
  country: "Country",
  selectCountry: "Please select a country",

  // Phone
  phone: "Phone number",
  phonePlaceholder: "Phone number",
  phoneCodePlaceholder: "Code",
  search: "Search...",
  noResults: "No results",

  // Legal
  terms: "I accept the",
  termsLink: "Terms & Conditions",
  privacy: "I accept the",
  privacyLink: "Privacy Policy",

  // Buttons
  save: "Save data",

  // Errors
  requiredFields: "Please fill in all required fields.",
  acceptTerms: "Please accept the Terms & Conditions and the Privacy Policy.",
  loginFirst: "Please log in first.",
  errorSaving: "Error saving user data!",
  errorLoading: "Error loading data."
},

password: {
  title: "Change password",
  oldPassword: "Current password",
  newPassword: "New password",
  confirmPassword: "Confirm new password",

  cancel: "Cancel",
  save: "Save",

  errorInvalid: "Please fill in all fields correctly.",
  errorGeneral: "Error changing password.",
  success: "Password changed successfully.",
  confirmLeave: "Do you want to save your changes?"
},
impressum: {
  title: "Legal Notice",
  company: "glampingoase GmbH",
  addressLine1: "Breechliweg 3",
  addressLine2: "5102 Rupperswil",
  country: "Switzerland",

  registryNumber: "Commercial register number: CHE-432.303.436",
  registryCourt: "Register authority: Commercial Register Office of Canton Aargau",

  emailLabel: "Email"
},

footer: {
  impressum: "Legal Notice"
},

objectList: {
  title: "Manage availability & prices",
  loading: "Loading...",
  notConfirmed: "not yet confirmed",
  editPrices: "Edit prices",
  editAvailability: "Edit availability",
  noObjectsLine1: "No accommodation created yet.",
  noObjectsLine2: "Do you want to create one now?",
  createObject: "Create new accommodation",
  imageAlt: "Object image"
},

prices: {
  openCalendar: "Open calendar",
  datePlaceholder: "dd.mm.yyyy",
  object: "Object",

  errorFetchCurrency: "Error fetching currency",
  errorFetchObjects: "Error loading objects",
  errorFetchObjectName: "Error loading object name",
  errorFetchSeasons: "Error fetching season data",
  errorFetchSeasonsAlert: "There was a problem loading the season data.",
  errorNotLoggedIn: "You are not logged in.",
  errorMissingFields: "Please fill in all fields.",
  errorEndBeforeStart: "The end date cannot be before the start date.",
  errorOverlap: "This season overlaps with an existing season.",

  errorSaveSeason: "Error saving season data",
  errorApiRequest: "API request error",
  errorSaveSeasonAlert: "There was a problem saving the season data.",

  confirmDeleteSeason: "Do you really want to delete the season",
  errorDeleteSeason: "Error deleting season",
  errorDeleteSeasonAlert: "The season could not be deleted.",

  errorFinishEditingFirst: "Please finish the current edit before adding a new season.",

  tabPrices: "Prices",
  tabAdditionalCosts: "Additional costs",
  tabCurrency: "Currency",
  tabAvailability: "Availability",
  tabObjectList: "Object overview",

  pricesFor: "Prices for",

  hidePastSeasons: "Hide past seasons",
  showPastSeasons: "Show past seasons",

  seasonName: "Season name",
  pricePerNight: "Price per night in",

  saving: "Saving...",
  cancel: "Cancel",
  addSeason: "+ Add season",

infoTitle: "How do I enter prices?",

infoText: "For each season, you define a period with a start and end date.\n\nYou can assign any name to the season. This name is only for your own overview and is not shown to customers.\n\nThe price applies per night. Make sure that season periods do not overlap. If they do, an error message will appear.\n\nOnce all information is correct, confirm the entry using the checkmark in the green field. The season will be saved, and you can add the next one using '+ Add season'.\n\nOnly one season can be edited at a time, as the system automatically checks for overlapping dates during each edit.\n\nYou can edit existing seasons using the pencil icon or delete them using the trash icon. These actions are only available when no other season is being edited.\n\nUsing the 'Show past seasons' button, you can display previous seasons. These are for viewing only and cannot be edited.",

close: "Close",

selectCurrencyTitle: "Select currency",
selectCurrencyText: "Please choose a currency before adding prices.",
currencyRequired: "Please select a currency first.",

},

additionalCosts: {
  title: "Additional costs for",
  object: "Object",

  add: "Add additional cost",

  selectType: "Select cost type",
  selectUnit: "Select unit",
  pricePlaceholder: "Price in",

  saving: "Saving...",
  cancel: "Cancel",

  finishEditingFirst: "Please finish editing before adding new costs.",
  fillAllFields: "Please fill in all fields.",
  confirmDelete: "Do you really want to delete this cost?",

  errorLoadingTypes: "Error loading cost types",
  errorLoadingUnits: "Error loading units",
  errorLoadingCosts: "Error fetching additional costs",
  errorSaving: "Error saving",
  errorDeleting: "Error deleting",

},
currency: {
  title: "Currency for",
  select: "Select currency",
  saving: "Saving...",
  save: "Save currency",
  saved: "Currency saved successfully",
  errorLoadingCurrencies: "Error loading available currencies",
  errorLoadingObjectCurrency: "Error loading object currency",
  errorLoadingObjectName: "Error loading object name",
  errorSaving: "Error saving currency",
  object: "Object"
},

availability: {
  settingsTitle: "Settings",
  modeTitle: "Availability mode",
  modeIcal: "iCal synchronization",
  modeManual: "Manual availability",

  warningSwitch: "Switching the mode will delete existing availabilities. Continue?",
  saved: "Settings saved.",

  modalTitle: "How would you like to manage your availability?",
  modalText: "Please choose one of the two options. You can change this at any time.",
  chooseIcal: "iCal synchronization",
  chooseManual: "Manual entry",

  errorLoading: "Error loading availability.",
  tabsAriaLabel: "Availability tabs",

  tabSettings: "Settings",
  tabIcal: "Manage iCal",
  tabManual: "Enter availability",
  tabPrices: "Prices",
  tabObjectList: "Object overview"
},

availabilityManual: {
  editAvailability: "Edit availability",
  loadingObject: "Loading object information…",

  legendAvailable: "Available",
  legendDelete: "Delete",

  savedSuccess: "Availability saved successfully!",
  savedPartialError: "Some availability entries could not be saved or deleted.",
  errorSaving: "Error while saving.",
  errorNoObjectId: "Error: No object ID found."
},

availabilityIcal: {
  title: "iCal import",
  loading: "Loading…",

  placeholderUrl: "https://example.com/calendar.ics",
  testPreview: "Test preview",
  testing: "Testing…",
  showSynced: "Show synced data",

  save: "Save",
  saving: "Saving...",
  remove: "Remove",

  lastSync: "Last synchronization",
  previewFailed: "Preview failed",
  previewCalendar: "Preview (calendar)",

  prev: "Back",
  next: "Next",

  errorLoading: "Error loading iCal data.",
  errorNoUrl: "No iCal link provided.",
  errorPreview: "There was an error fetching the link.",
  errorInvalidUrl: "Invalid URL.",
  errorSaving: "Saving failed.",
  errorRemove: "Removal failed",
  removed: "iCal link removed",
  saved: "iCal link saved. Synchronization started.",
  errorLoadSynced: "Error loading synced data.",
  errorNoObjectId: "No object ID found."
},


newObjectModal: {
  title: "Existing accommodation draft found",
  description:
    "You already have a started accommodation. Would you like to continue or start a new one and overwrite the existing data?",
  continue: "Continue with existing draft",
  startNew: "Start new"
},

 object: {
    tabs: [
    "Basic data",
    "Rooms",
    "Amenities / Surroundings",
    "Occupancy",
    "Description",
    "Images",
    "Submit"
  ],

    step1: {
      title: "Step 1: General Information",

      fields: {
        name: "Property name",
        street: "Street",
        house_number: "House number",
        postal_code: "Postal code",
        city: "City",
        object_type: "Property type",
        country: "Country",
        region: "Region",
        licence_number: "License number"
      },

      select: {
        choose: "Please choose"
      },

      map: {
        info: "The marker is automatically set based on the entered address. If the position is not accurate, you can move the marker manually.",
        reset: "Reset marker to entered address",
        load_error: "Map cannot be loaded.",
        loading: "Loading map..."
      },
      
      geocode: {
        failed: "Geocoding failed.",
        missing_fields: "Please fill in all address fields and ensure the Google Maps API is loaded."
    }
    },
    step2: {
      title: "Step 2: Rooms & Amenities",
      addRoom: "Add room",
      roomCountTitle: "How many rooms does your accommodation have?",
      roomCountDescription: "Enter the number for each room type. Afterwards you can edit each room individually.",
      roomCountSharedHint: "Shared rooms such as bathrooms and kitchens also count.",
      addAllRooms: "Add all rooms",
      roomType: "Room type",
      amount: "Quantity",
      select: "Please select",
      usage: "Usage",
      private: "Private use",
      shared: "Shared use",
      onlyOneAllowed: "only 1 allowed",

      // Beds
      beds: "Beds",
      addBed: "Add bed",
      bedType: "Bed type",
      size: "Size",
      sizeWidth: "Width (cm)",
      sizeLength: "Length (cm)",
      sizeOptional: "Optional",
    },

  step3: {
    title: "Step 3: Amenities & Surroundings",
    general: "General amenities",
    outdoor: "Outdoor amenities",
    environmentAmenities: "Surroundings amenities",
    environmentCards: "Surroundings",
    errorLoading: "Error loading amenities."
  },
    step4: {
    title: "Step 4: Occupancy & Contact Options",

    maxOccupancy: "Maximum occupancy",
    maxPets: "Maximum number of pets",
    minNights: "Minimum stay",

    selectPlaceholder: "Please select",

    arrivalDays: "Arrival days",

    earliestCheckin: "Earliest check-in",
    latestCheckout: "Latest check-out",

    rules: "Rules",
    partyAllowed: "Parties allowed",
    smokingAllowed: "Smoking allowed",
    yes: "Yes",
    no: "No",

    contactOptions: "Contact options",
    contactHow: "How should guests contact you?",
    contactBoth: "Both",
    contactWebsite: "Website",
    contactWebsitePlaceholder: "https://example.com",
    contactEmail: "Email for contact form",

    invalidEmail: "Please enter a valid email address.",
    errorLoadingArrivalDays: "Error loading arrival days."
  },
  step5: {
    title: "Step 5: Property Description",
    activitiesTitle: "Activities nearby",
    activitiesPlaceholder: "Describe what guests can find near your property.",
    descriptionTitle: "Property description",
    descriptionPlaceholder: "Please provide a meaningful text that describes your property well."
  },
  step6: {
    title: "Step 6: Upload images",

    titleImage: "Title image",
    additionalImages: "Additional images (max. 20)",

    selectOrDragTitle: "Select or drag your title image here",
    dragTitleHere: "Drag your title image here",

    selectOrDragAdditional: "Select files or drag them here",
    dragAdditionalHere: "Drag additional images here",

    uploaded: "Image uploaded",
    uploadedCount: "{n} image(s) uploaded",

    errorMinSize: "Image must be at least {w}x{h} pixels.",
    errorInvalidFormat: "Invalid image format."
  },
  step7: {
    title: "Step 7: Finalize & choose subscription",
    intro: "Almost done! Choose your subscription model and check if all steps are complete.",

    subscriptionTitle: "Choose subscription model",

    freeTitle: "Free",
    freePrice: "Free",
    freeDescription: "Placeholder text. Description goes here.",

    monthlyTitle: "Monthly",
    monthlyPrice: "2 CHF / month",
    monthlyDescription: "Placeholder text. Description goes here.",

    yearlyTitle: "Yearly",
    yearlyPrice: "20 CHF / year",
    yearlyDescription: "Placeholder text. Description goes here.",

    overviewTitle: "Overview of your information",
    fix: "Fix",

    overviewItems: [
      { step: 1, title: "Basic data" },
      { step: 2, title: "Rooms" },
      { step: 3, title: "Amenities / Surroundings" },
      { step: 4, title: "Occupancy" },
      { step: 5, title: "Description" },
      { step: 6, title: "Images" }
    ],

    errorUnknown: "Unknown error.",
    errorGeneral: "An error occurred."
  }

  }

};
